import { Control, Controller, FieldErrors } from "react-hook-form";
import { PurchaseShippingDocument } from "../../../../interfaces/Purchases/ShippingDocuments/purchaseShippingDocuments";
import { FormsErrors } from "../../../../hooks/Forms/FormsErrors";
import { useTranslation } from "react-i18next";
import { TextField } from "@mui/material";

type AnnotationsPurchaseShippingDocumentProps = {
  control: Control<PurchaseShippingDocument>,
  errors: FieldErrors<PurchaseShippingDocument>,
  isEdit?: boolean,
}

export const AnnotationsPurchaseShippingDocument = ({
  control,
  errors,
  isEdit,
}: AnnotationsPurchaseShippingDocumentProps) => {
  const { GetError } = FormsErrors();
  const [t] = useTranslation("global");

  return (
      <>
          <div className='w-100'>
              <Controller
                  name="notes"
                  control={control}
                  rules={{}}
                  render={({ field }) => (
                      <TextField
                          variant="filled"
                          label={`${t("purchaseshippingdocuments.fields.notes")}`}
                          ref={field.ref}
                          value={field.value}
                          multiline
                          minRows={5}
                          onChange={(event) => { field.onChange(event.target.value) }}
                          error={!!errors.notes}
                          helperText={GetError(errors.notes?.type)}
                          size="small"
                          sx={{ width: "100%", paddingRight: 2 }}
                          disabled={isEdit}
                      />
                  )}
              />
          </div>
      </>
  )
}
